/*
Suresh Peddavoora 10/28/2022 3075154998  Added Class Name for Text Fields and Buttons
 Lalitha  11/9/2022  3075154998 Rename Button Cancel to Reset
*/
import React, {useEffect, useContext} from 'react';
import {Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';

const ConditionForm = ({
  setRecordData,
  recordData,
  setConditionData,
  conditionData,
  setFilterOpen,
  handleConditionClose,
  conditionRowData,
  isConditionEditMode,
  setIsConditionEditMode,
  conditionCode,
  ruleGroupSNo,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  let initialValues = {
    description: isConditionEditMode && conditionRowData?.description ? conditionRowData?.description : '',
    displayFormat: isConditionEditMode && conditionRowData?.displayFormat ? conditionRowData?.displayFormat : '',
    endPosition: isConditionEditMode && conditionRowData?.endPosition ? conditionRowData?.endPosition : '',
    fieldName: isConditionEditMode && conditionRowData?.fieldName ? conditionRowData?.fieldName : '',
    fieldType: isConditionEditMode && conditionRowData?.fieldType ? conditionRowData?.fieldType : '',
    recordCode: isConditionEditMode && conditionRowData?.operator ? conditionRowData?.operator : '',
    recordFieldId: isConditionEditMode && conditionRowData?.operator ? conditionRowData?.operator : '',
    startPosition: isConditionEditMode && conditionRowData?.startPosition ? conditionRowData?.startPosition : '',
    groupName: isConditionEditMode && conditionRowData?.groupName ? conditionRowData?.groupName : '',
  };

  useEffect(() => {
    initialValues = {
      description: isConditionEditMode && conditionRowData?.description ? conditionRowData?.description : '',
      displayFormat: isConditionEditMode && conditionRowData?.displayFormat ? conditionRowData?.displayFormat : '',
      endPosition: isConditionEditMode && conditionRowData?.endPosition ? conditionRowData?.endPosition : '',
      fieldName: isConditionEditMode && conditionRowData?.fieldName ? conditionRowData?.fieldName : '',
      fieldType: isConditionEditMode && conditionRowData?.fieldType ? conditionRowData?.fieldType : '',
      recordCode: isConditionEditMode && conditionRowData?.operator ? conditionRowData?.operator : '',
      recordFieldId: isConditionEditMode && conditionRowData?.operator ? conditionRowData?.operator : '',
      startPosition: isConditionEditMode && conditionRowData?.startPosition ? conditionRowData?.startPosition : '',
      groupName: isConditionEditMode && conditionRowData?.groupName ? conditionRowData?.groupName : '',
    };
  }, [conditionRowData]);


  const handleSubmit = (data) => {
    const copiedData = [...recordData];
    if (!isConditionEditMode) {
      copiedData.push({...data});
      setRecordData(copiedData);
      setFilterOpen(false);
    } else {
      const updatedActionData = copiedData.map((item, i) => {
        if (i === conditionCode) {
          return {
            ...item,
            description: data.description,
            displayFormat: data.displayFormat,
            endPosition: data.endPosition,
            fieldName: data.fieldName,
            fieldType: data.fieldType,
            recordCode: data.recordCode,
            recordFieldId: data.recordCode,
            seqNum: i + 1,
            startPosition: data.startPosition,
            groupName: data.groupName,
          };
        } else {
          return {...item};
        }
      });
      setRecordData(updatedActionData);
      setFilterOpen(false);
      setIsConditionEditMode(false);
    }
  };
  // const schema = Yup.object().shape({
  //   code:
  //     conditionRowData?.code === currentRuleCode && isConditionEditMode
  //       ? ""
  //       : Yup.string()
  //         .notOneOf(
  //           conditionData.map((data) => data.code),
  //           "Rule code already exists"
  //         )
  //         .required("Rule Code is required").nullable(),
  // });
  return (
    <div className={classes.dialoguecardStyles}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        // validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleSubmit,
            handleReset,
            handleBlur,
          } = props;
          return (
            <div>
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div className="global-field-textfields">
                  <Grid container spacing={2}>
                    <Grid item xs={4} className="pl-md-1 form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Description`}
                        label="Description"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="description"
                        value={values?.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.description}
                        error={Boolean(touched.description && errors.description)}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.description && errors.description}
                      </FormHelperText>
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder="Enter Begin"
                        label="Begin"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="startPosition"
                        value={values?.startPosition}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter end`}
                        label="End"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="endPosition"
                        value={values?.endPosition}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter Length`}
                        label="Length"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="len"
                        value={values.len}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter Field`}
                        label="Field"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="fieldName"
                        value={values.fieldName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter Type`}
                        label="Type"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="fieldType"
                        value={values.fieldType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter Format Spec`}
                        label="Format Spec"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="displayFormat"
                        value={values.displayFormat}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter Group`}
                        label="Group"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="groupName"
                        value={values.groupName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </div>
                <div className="text-center">
                  <div className="row justify-content-center mb-1">
                    <Button
                      type="button"
                      onClick={() => handleReset()}
                      variant="outlined"
                      className={`reset-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default ConditionForm;
